import React from 'react';

import {Box, Container} from '@material-ui/core';

import Divider from "@material-ui/core/Divider";
import Header from "./Header";


const App = () => {


    return (
        <Container maxWidth={"md"} style={{padding: '1rem'}}>
            <Header/>
            <Box>
                <h2>The SHeLL Editor has moved!</h2>
                <Divider style={{margin: "1rem 0"}}/>
                <p>
                    We're excited to announce our <b>new</b> version of the SHeLL Editor: <br/><a
                    href={"https://healthliteracysolutions.com.au/"}
                    target={"_blank"}>https://healthliteracysolutions.com.au/</a><br/>
                </p>
                <p>Basic features are free for everyone. Advanced features are available to University of Sydney staff and students, and NSW Health staff through existing organisational subscriptions. Please register or log in <a
                        href={"https://www.healthliteracysolutions.com.au/register"} target={"_blank"}>here</a> using your organisational email to continue.
                </p>
                <Divider style={{margin: "1rem 0"}}/>
                <p>
                    This research version closed in October, 2025. It was funded by a seed grant which has expired.
                    The trial evaluating the tool is now complete and published here: <br/><a
                    href={"https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2824548"}
                    target={"_blank"}>https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2824548</a>
                </p>
            </Box>
        </Container>
    );
};


export default App;
